import { membershipUrl } from "../lib/membershipUrl";
import { authPost } from "./authMiddleware"

export const postLogout = async returnUrl => {
    return authPost(membershipUrl() + 'api/sso-logout', {return_to: returnUrl});
}